// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"d9c769f1","container":"dff056cf","header":"d9756865","rightHeader":"a520e097","left":"d76c0741","numberInput":"bf137d59","durationPopoverContent":"d7c13122"};